import { render, staticRenderFns } from "./MinimalLayout.vue?vue&type=template&id=4eb66b91"
import script from "./MinimalLayout.vue?vue&type=script&lang=js"
export * from "./MinimalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports